<template>
  <div class="star">
    <!-- // 用于父子组件双向绑定 -->
    <input type="hidden" v-model="value" />
    <!-- // 不可点击的星星 -->
    <div v-if="readonly">
      <!-- // 满星 -->
      <!-- <img v-for="i in parseInt(value)" :key="i" :src="full" /> -->
      <Icon
        type="md-star"
        color="#f5a623"
        :size="size"
        v-for="i in parseInt(value)"
        :key="i"
      />
      <!-- // 半星 -->
      <!-- <img v-if="value.toString().indexOf('.') > 0" :src="half" /> -->
      <Icon
        type="md-star-half"
        color="#f5a623"
        :size="size"
        v-if="value.toString().indexOf('.') > 0"
      />
      <!-- // 灰星 -->
      <!-- <img v-for="i in parseInt(5 - value)" :key="i * 6" :src="empty" /> -->
      <Icon
        type="md-star"
        color="#e9e9e9"
        :size="size"
        v-for="i in parseInt(5 - value)"
        :key="i * 6"
      />
    </div>
    <!-- // 可点击的星星 -->
    <div v-else>
      <!-- // 满星
      <img v-for="i in num" :key="i" :src="full" @click="num = i" /> -->
      <Icon
        type="md-star"
        color="#f5a623"
        v-for="i in num"
        :key="i"
        :size="size"
        @mouseenter.native="num = i"
        @click="num = i"
      />
      <!-- // 灰星
      <img
        v-for="i in parseInt(5 - num)"
        :key="i * 5"
        :src="empty"
        @click="num += i"
      /> -->
      <Icon
        type="md-star"
        color="#e9e9e9"
        v-for="i in parseInt(5 - num)"
        :key="i * 5"
        :size="size"
        @mouseenter.native="num += i"
        @click="num += i"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 分值
    value: {
      type: Number,
      default: 0,
    },
    // 只读，表示可以点击还是不可点击
    readonly: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 24,
    },
  },
  data() {
    return {
      num: 0,
      //   full: require("./红星.png"),
      //   empty: require("./灰星.png"),
      //   half: require("./半星.png"),
    };
  },
  //   mounted() {
  //     this.$emit("input", this.num);
  //   },
  watch: {
    num() {
      // 可点击状态下，双向绑定的分值改变
      this.$emit("input", this.num);
    },
    // value() {
    //   console.log(this.value);
    // },
  },
};
</script>

<style scoped>
.star {
  display: inline-block;
  /* float: left; */
  padding: 5px 0;
}
.star img {
  width: 24px;
  height: 24px;
  margin: 0 2px;
}
</style>